import { memo } from 'react';
import { useSavedSessionState } from '../../../../context/SavedSession/SavedSession';
import { useSavedSessionTrySave } from '../../../../context/SavedSession/Hooks';
import { useLocalization } from '../../../../context/Localization/localization';
import { IconButton } from '../../../../controls/IconButton/IconButton';
import { GMSizedIcon } from '../../../../controls/Icon';
import type { SaveIconProps } from './SaveIcon.types';

export const SaveIcon = memo(({ slim }: SaveIconProps) => {
    const savedSessionState = useSavedSessionState();
    const { trySave } = useSavedSessionTrySave();
    const Localization = useLocalization();

    return savedSessionState.showSaveButton ? (
        <IconButton
            headerIcon
            slim={slim}
            onClick={() => trySave()}
            sizedIcon={<GMSizedIcon iconType={'Save'} iconSize={slim ? 'custom' : 'medium'} />}
            label={Localization.Save}
            title={Localization.ClickToSave}
            ariaLabel={Localization.ClickToSave}
            id={Localization.ClickToSave}
        />
    ) : null;
});
